import {
  FETCH_SHQ_BOXES,
  FETCH_SHQ_SHIPPING_GROUPS,
  FETCH_SHQ_ORIGINS,
  FETCH_SHQ_PACKING_RULES
} from '../actions/types'

const initialState = {
  boxes: [],
  origins: [],
  packingRules: [],
  groups: []
}

export default (state = initialState, action) => {
  switch (action.type) {
    case FETCH_SHQ_BOXES:
      return {
        ...state,
        boxes: action.payload
      }
    case FETCH_SHQ_SHIPPING_GROUPS:
      return {
        ...state,
        groups: action.payload
      }
    case FETCH_SHQ_ORIGINS:
      return {
        ...state,
        origins: action.payload
      }
    case FETCH_SHQ_PACKING_RULES:
      return {
        ...state,
        packingRules: action.payload
      }
    default:
      return state
  }
}
